import { Link } from 'react-router-dom';
import { pathFor, type PageId } from '@nexa/content';
import { useLocale } from '@/core/i18n';

export interface PageLinkProps {
  readonly page: PageId;
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly ariaCurrent?: boolean;
}

/**
 * Cách DUY NHẤT được phép dùng để liên kết nội bộ. Nhận id trang, không nhận URL.
 *
 * Nhờ vậy: (1) đổi slug chỉ sửa ở bảng route, không phải grep cả app; (2) không thể quên
 * prefix locale — lỗi này tạo ra liên kết chéo ngôn ngữ, làm Google index lẫn hai bản;
 * (3) không thể gõ sai URL thành liên kết chết mà chỉ phát hiện lúc bấm.
 */
export function PageLink({ page, children, className, ariaCurrent }: PageLinkProps) {
  const locale = useLocale();
  return (
    <Link
      to={pathFor(page, locale)}
      className={className}
      {...(ariaCurrent === true ? { 'aria-current': 'page' as const } : {})}
    >
      {children}
    </Link>
  );
}
